import { Injectable } from '@angular/core';
// models
import { SensorField } from '../models/sensor-field';
// services
// import { CalendlyService } from './calendly.service';
import { FormValidatorService } from './form-validator.service';
import { RouterService } from './router.service';

@Injectable({
  providedIn: 'root'
})
export class SensorFormService {

  public fields_list: Array<SensorField> = [];

  constructor(
    private formValidatorService: FormValidatorService,
    private routerService: RouterService) { }

  setSurveyFieldList(sensor_fields: any, default_fields: any): Promise<SensorField[]> {
    this.fields_list = [];
    return new Promise(async (resolve, reject) => {

      // check default fields
      if (default_fields.name_visible) { // name field
        this.fields_list.push({
          "label": 'NAME',
          "visibility": true,
          "initial_visibility": true,
          "mandatory": default_fields.name_mandatory,
          "validation_type": 'GENERAL',
          "default_field": true
        })
      }
      if (default_fields.email_visible) { // email field
        this.fields_list.push({
          "label": 'EMAIL',
          "visibility": true,
          "initial_visibility": true,
          "mandatory": default_fields.email_mandatory,
          "validation_type": 'EMAIL',
          "default_field": true
        })
      }
      if (default_fields.phone_visible) { // phone field
        this.fields_list.push({
          "label": 'PHONE',
          "visibility": true,
          "initial_visibility": true,
          "mandatory": default_fields.phone_mandatory,
          "validation_type": 'PHONE',
          "default_field": true
        })
      }
      // check sensor fields
      if (sensor_fields != null) {
        if (sensor_fields.length) {
          for (const [i, sensor_field] of sensor_fields.entries()){

            let answer_param = await this.getSurveyFieldsParamsInURL(sensor_field.label as string)
            if (answer_param != null) {
              sensor_field.value = answer_param
              sensor_field.from_param = true
            } else sensor_field.from_param = false

            this.fields_list.push({
              "label": sensor_field.label,
              "validation_type": this.formValidatorService.validation_id_to_type[sensor_field.validation_type],
              "mandatory": sensor_field.mandatory,
              "answer": sensor_field.value,
              "visibility": sensor_field.visible,
              "initial_visibility": sensor_field.visible,
              "extra_data": true,
              "from_param": sensor_field.from_param
            })
            // if (sensor_field.label.includes('calendly')) {
            //   this.fields_list[this.fields_list.length - 1].validation_type = "CALENDLY"
            // }
            if (i == sensor_fields.length - 1) resolve(this.fields_list)

          }
        } else resolve(this.fields_list)
      } else resolve(this.fields_list)
      
    })
  }
  getSurveyFieldsParamsInURL(param: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.routerService.getParams().then((resp) => {
        if (resp[param] != undefined) resolve(resp[param])
        else resolve(null)
      })
    })
  }
}
